import React, { useEffect, useState } from "react";
import { HiMenuAlt3, HiX } from "react-icons/hi";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = ["Home", "Portfolio", "Services", "Testimonials", "Contact"];

  return (
    <header
      className={`fixed left-0 top-0 z-50 w-full transition-all duration-500 ${
        scrolled
          ? "bg-black/98 shadow-2xl backdrop-blur-md border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6">
        <a href="#home" className="flex flex-col group">
          <h1 className="text-3xl font-bold tracking-wider text-white group-hover:text-amber-400 transition">
            STUDIO<span className="text-amber-400">44</span>
          </h1>
          <span className="text-[9px] uppercase tracking-[8px] text-gray-500 font-medium">
            Photography
          </span>
        </a>

        <nav className="hidden items-center gap-12 lg:flex">
          {navLinks.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase().replace(/\s/g, "")}`}
              className="group relative text-xs uppercase tracking-[3px] text-white font-medium transition hover:text-amber-400"
            >
              {item}
              <span className="absolute -bottom-2 left-0 h-[2px] w-0 bg-amber-400 transition-all duration-300 group-hover:w-full"></span>
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="hidden border-2 border-amber-400 px-6 py-2.5 text-xs uppercase tracking-[2px] text-amber-400 font-bold transition hover:bg-amber-400 hover:text-black lg:block"
        >
          Book Session
        </a>

        <button
          className="text-white lg:hidden transition hover:text-amber-400"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <HiX size={28} /> : <HiMenuAlt3 size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`overflow-hidden bg-black/95 backdrop-blur-md border-b border-white/5 transition-all duration-500 lg:hidden ${
          isOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-6 space-y-1">
          {navLinks.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase().replace(/\s/g, "")}`}
              onClick={() => setIsOpen(false)}
              className="py-3 uppercase tracking-[2px] text-sm text-white transition hover:text-amber-400 font-medium"
            >
              {item}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setIsOpen(false)}
            className="mt-6 border-2 border-amber-400 py-2.5 text-center uppercase tracking-[2px] text-xs text-amber-400 font-bold transition hover:bg-amber-400 hover:text-black"
          >
            Book Session
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;